import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import {
  InputAdornment,
  MenuItem,
  Select,
  Typography,
  OutlinedInput,
} from '@mui/material';
import { useAtomValue } from 'jotai';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { userBranchesAtom } from '../../Atoms';
import { ICONS } from '../../Utils/constants/icons';

const BranchIcon = ICONS.BRANCHES_MANAGEMENT;

const styles = {
  select: {
    mb: '16px',
    // Sized so the longest branch name still fits the 288px drawer.
    fontSize: '13px',
    fontWeight: 500,
    '& .MuiOutlinedInput-notchedOutline': {
      border: '2px solid #d6d6d6',
      borderRadius: '10px',
    },
    '& .MuiSelect-select': {
      padding: '12px 32px 12px 0',
    },
  },
  fieldCaption: {
    color: 'text.secondary',
    fontSize: '12px',
    fontWeight: 600,
    mb: '4px',
  },
};

const BranchSelect = function BranchSelect({
  handleChangeBranch = () => {},
}) {
  const intl = useIntl();
  const userBranches = useAtomValue(userBranchesAtom);
  const [value, setValue] = useState(
    sessionStorage.getItem('selectedBranch')
      ? JSON.parse(sessionStorage.getItem('selectedBranch'))?.id
      : userBranches?.find((x) => x?.isDefault)?.id
  );

  const onChange = (event) => {
    setValue(event.target.value);
    if (event.target.value)
      handleChangeBranch(
        userBranches?.find((x) => x?.id === event.target.value)
      );
  };

  return (
    <>
      <Typography variant="subtitle2" sx={styles.fieldCaption}>
        {intl.messages.BRANCH}
      </Typography>
      <Select
        id="branch-select"
        value={value}
        onChange={onChange}
        fullWidth
        IconComponent={KeyboardArrowDownIcon}
        input={
          <OutlinedInput
            sx={styles.select}
            startAdornment={
              <InputAdornment position="start">
                <BranchIcon fontSize="small" />
              </InputAdornment>
            }
          />
        }
      >
        {userBranches.map(({ id, branchDescription }) => (
          <MenuItem key={id} value={id}>
            {branchDescription}
          </MenuItem>
        ))}
      </Select>
    </>
  );
};

export default BranchSelect;
